export default "__VITE_ASSET__YaG19rES__"